import { render, staticRenderFns } from "./allTeam.vue?vue&type=template&id=2227abb9&scoped=true&"
import script from "./allTeam.vue?vue&type=script&lang=js&"
export * from "./allTeam.vue?vue&type=script&lang=js&"
import style0 from "./allTeam.vue?vue&type=style&index=0&id=2227abb9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2227abb9",
  null
  
)

export default component.exports